/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordValidationRuleset } from './PasswordValidationRuleset';
import {
    PasswordValidationRulesetFromJSON,
    PasswordValidationRulesetFromJSONTyped,
    PasswordValidationRulesetToJSON,
    PasswordValidationRulesetToJSONTyped,
} from './PasswordValidationRuleset';

/**
 * 
 * @export
 * @interface PasswordResetChallengeOptions
 */
export interface PasswordResetChallengeOptions {
    /**
     * 
     * @type {PasswordValidationRuleset}
     * @memberof PasswordResetChallengeOptions
     */
    validation_rules: PasswordValidationRuleset;
}

/**
 * Check if a given object implements the PasswordResetChallengeOptions interface.
 */
export function instanceOfPasswordResetChallengeOptions(value: object): value is PasswordResetChallengeOptions {
    if (!('validation_rules' in value) || value['validation_rules'] === undefined) return false;
    return true;
}

export function PasswordResetChallengeOptionsFromJSON(json: any): PasswordResetChallengeOptions {
    return PasswordResetChallengeOptionsFromJSONTyped(json, false);
}

export function PasswordResetChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetFromJSON(json['validation_rules']),
    };
}

export function PasswordResetChallengeOptionsToJSON(json: any): PasswordResetChallengeOptions {
    return PasswordResetChallengeOptionsToJSONTyped(json, false);
}

export function PasswordResetChallengeOptionsToJSONTyped(value?: PasswordResetChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validation_rules': PasswordValidationRulesetToJSON(value['validation_rules']),
    };
}

